import { filterXSS, whiteList } from 'xss';

export default function (value, options = {}) {
    if (!value) {
        return '';
    }
    const res = filterXSS(
        value,
        Object.assign(
            {
                whiteList: {
                    ...whiteList,
                    video: [
                        'style',
                        'autoplay',
                        'controls',
                        'crossorigin',
                        'loop',
                        'muted',
                        'playsinline',
                        'poster',
                        'preload',
                        'src',
                        'height',
                        'width',
                    ],
                    a: ['target', 'href', 'title', 'style', 'rel', 'class'],
                    span: ['data-unicode', 'style', 'class', 'id'],
                    h1: ['class', 'style', 'id'],
                    h2: ['class', 'style', 'id'],
                    h3: ['class', 'style', 'id'],
                    h4: ['class', 'style', 'id'],
                    div: ['class', 'style', 'id', 'data-child-count'],
                    img: ['style', 'src', 'id', 'alt', 'title', 'width', 'height', 'class', 'describe', 'isupload'],
                },
            },
            options
        )
    );
    return res;
}
